module.exports = __webpack_public_path__ + "static/img-slide-2-9a7abefa94b02a57193b3f35824f764e.png";